<template>
  <SvgBase width="34" height="34" viewBox="0 0 32 32" fill="none">
    <title>RFID Chip Signal</title>
    <rect x="4" y="10" width="12" height="12" rx="2" :stroke="color" stroke-width="2" />
    <path d="M8 14H12M8 18H12" :stroke="color" stroke-width="1.5" stroke-linecap="round" />
    <g transform="translate(2, 0)">
      <path
        d="M18 12C20.2091 12 22 13.7909 22 16C22 18.2091 20.2091 20 18 20"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M18 8C22.4183 8 26 11.5817 26 16C26 20.4183 22.4183 24 18 24"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
      />
    </g>
  </SvgBase>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import SvgBase from './SvgBase.vue'

@Options({
  components: {
    SvgBase,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
})
export default class IconRfid extends Vue {}
</script>
